<template>
    <section class="history">

        <div>
            <div class="history__list ">
                <div class="history__item" v-for="item in items">{{ item.label }}</div>
            </div>
            <div class="history__info">
                <div class="history__content" v-for="item in items">
                    <img class="history__img" :src="item.src" alt="">
                    <div class="history__descr">
                        <div class="arrows">
                            <div class="slider__navigation">
                                <button type="button" aria-label="Предыдущий слайд"
                                        class="slider__arrow slider__arrow--prev js-slider-prev" tabindex="0">
                                    <span class="slider__arrow-icon">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.6189 15.9997L19.6095 23.038C20.1302 23.563 20.1302 24.4142 19.6095 24.9393C19.0889 25.4643 18.2448 25.4643 17.7242 24.9393L9.79101 16.9504C9.27031 16.4253 9.27031 15.574 9.79101 15.0489L17.7242 7.0601C18.2448 6.53509 19.0889 6.53509 19.6095 7.0601C20.1302 7.58511 20.1302 8.43632 19.6095 8.96132L12.6189 15.9997Z"
                                                  fill="#52525B"/>
                                        </svg>
                                    </span>
                                </button>
                                <button type="button" aria-label="Следующий слайд"
                                        class="slider__arrow slider__arrow--next js-slider-next" tabindex="0">
                                    <span
                                            class="slider__arrow-icon">
                                       <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.3811 16.0003L12.3905 8.96197C11.8698 8.43697 11.8698 7.58576 12.3905 7.06075C12.9111 6.53574 13.7552 6.53574 14.2758 7.06075L22.209 15.0496C22.7297 15.5747 22.7297 16.426 22.209 16.9511L14.2758 24.9399C13.7552 25.4649 12.9111 25.4649 12.3905 24.9399C11.8698 24.4149 11.8698 23.5637 12.3905 23.0387L19.3811 16.0003Z"
                                                  fill="#52525B"/>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class="history__title">{{ item.label }}</div>
                        <div class="history__text" v-html="item.descr"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "history",
    props: {
        items: Array | String | Number | Boolean | Object,
    },
    data() {
        return {
            tab: null,
            /*items: [
                {
                    label: "1993 — 1998",
                    src: "/upload/history.jpg",
                    descr: "2005 год – Начало масштабной экспансии: открыто 20 офисов продаж по всей России, что позволило укрепить позиции на рынке и обеспечить клиентам оперативное обслуживание в различных регионах. \n" +
                        "2008 год – Важный этап развития: компания прошла сертификацию по международному стандарту ISO 9001:2008, подтвердив высокое качество продукции и процессов. \n" +
                        "2010 год – Выход на международный уровень: открытие филиала в Казахстане (г. Алматы), что стало первым шагом в расширении географии присутствия за пределами России.",
                },
                {
                    label: "1998 — 2005",
                    src: "/upload/history.jpg",
                    descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",

                },
                {
                    label: "2005 — 2010",
                    src: "/upload/history.jpg",
                    descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
                },
                {
                    label: "2010 — 2017",
                    src: "/upload/history.jpg",
                    descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
                },
                {
                    label: "2017 — 2021",
                    src: "/upload/history.jpg",
                    descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
                },
                {
                    label: "2021 — текущий год",
                    src: "/upload/history.jpg",
                    descr: "Мы крупнейших производитель и дистрибьютор транспортной упаковки. Инвестиции в развитие высокотехнологичной упаковки позволяют бизнесу предлагать лучшие решения для транспортировки грузов.",
                },

            ]*/
        }
    },

}
</script>

<style lang="scss" scoped>
.history {

  &__list {
    width: 100%;
    max-width: 1840px;
    margin-bottom: 60px;

    @media (max-width: 1024px) {
      margin-bottom: 30px;
    }
  }

  &__item {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.02px;
    color: #212424;
    padding-top: 20px;
    border-top: 4px solid #ECECED;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover, &:focus {
      color: #FF867E;
    }

    @media (max-width: 1400px) {
      font-size: 20px;
      line-height: 28px;
    }

    @media (max-width: 1024px) {
      font-size: 16px;
      line-height: 24px;
    }

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 18px;
    }

    @media (max-width: 500px) {
      font-size: 12px;
      line-height: 16px;
    }

    @media (max-width: 350px) {
      font-size: 11px;
    }
  }

  &__content {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }

  &__img {
    border-radius: 40px;
    object-fit: cover;
    width: 100%;
    height: auto;
    max-width: 916px;
  }

  &__descr {
    position: relative;
    border-radius: 40px;
    padding: 48px;
    background: #F5F5F7;
    padding-bottom: 128px;


    @media (max-width: 425px) {
      padding: 24px;
      padding-bottom: 128px;
    }
  }

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-size: 64px;
    line-height: 72px;
    letter-spacing: -2.24px;
    color: #F94237;
    margin-bottom: 98px;

    @media (max-width: 1024px) {
      font-size: 40px;
      line-height: 48px;
      margin-bottom: 48px;
    }

    @media (max-width: 500px) {
      font-size: 36px;
      line-height: 44px;
      margin-bottom: 28px;
    }
  }

  &__text {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0px;
    color: #212424;

    @media (max-width: 1024px) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (max-width: 500px) {
      font-size: 18px;
      line-height: 24px;
    }
  }
}
</style>

<style lang="scss">
.history {
  & .arrows {
    position: absolute;
    left: 40px;
    bottom: 35px;

    @media (max-width: 425px) {
      left: 24px;
    }
  }

  & .slider__navigation {

    @media (max-width: 700px) {
      padding: 0;
    }
  }

  & .slider__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #E1E1E2;
    border-radius: 12px;
    background: #FFFFFF;
    width: 64px;
    height: 64px;

    &:hover {
      opacity: 1 !important;
      border: 1px solid #4F4D55;
    }
  }

  & .slider__arrow-icon {
    width: 32px;
    height: 32px;
  }

  &__list {
    .slick-track {
      display: flex;
      flex-wrap: wrap;
    }

    .slick-current {
      border-top: 4px solid #F94237;
      color: #F94237;
    }
  }


}
</style>